import React, { useMemo } from 'react';
import { Box } from '@material-ui/core';
import shuffleArray from '../../../../../../utils/shuffleArray';
import ViewerErrorBoundary from '../../../common/ViewerConclusion/ViewerErrorBoundary';
import { QuestionText, StyledRadioGroup, StyledRadioFormControlLabel, StyledRadio } from '../../QuestionViewer.styles';
const ChoiceQuestionViewer = ({ componentValues, setAnswer, answer, disabled }) => {
    var _a;
    const { question, answerOptions, hasRandomOrder } = componentValues !== null && componentValues !== void 0 ? componentValues : {};
    const handleChange = (event) => {
        setAnswer(event.target.value);
    };
    const possibleAnswers = useMemo(() => (hasRandomOrder ? shuffleArray(answerOptions) : answerOptions), [
        answerOptions,
        hasRandomOrder
    ]);
    return (React.createElement(ViewerErrorBoundary, null,
        React.createElement(QuestionText, null, question),
        React.createElement(Box, { display: "flex", flexDirection: "column" },
            React.createElement(StyledRadioGroup, { "aria-label": "multiple-choice-answer", name: "choice-answer", value: answer !== null && answer !== void 0 ? answer : '', onChange: handleChange }, (_a = possibleAnswers === null || possibleAnswers === void 0 ? void 0 : possibleAnswers.map((possibleAnswer) => (React.createElement(StyledRadioFormControlLabel, { key: possibleAnswer.key, value: possibleAnswer.key, control: React.createElement(StyledRadio, { color: "primary" }), label: possibleAnswer.text, disabled: disabled })))) !== null && _a !== void 0 ? _a : null))));
};
export default ChoiceQuestionViewer;
//# sourceMappingURL=index.js.map